import { render, staticRenderFns } from "./barChart.vue?vue&type=template&id=d0bf04d4&scoped=true&"
import script from "./barChart.vue?vue&type=script&lang=js&"
export * from "./barChart.vue?vue&type=script&lang=js&"
import style0 from "./barChart.vue?vue&type=style&index=0&id=d0bf04d4&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bf04d4",
  null
  
)

export default component.exports